/* eslint-disable sort-keys-fix/sort-keys-fix */
import { COMMUNITY_PAGES_PATH_PREFIX, type CommunityData } from "./types"

const S3_PREFIX = "https://media.werz.at/community-assets/hights/"

// Mapped from Figma "WERZ - Community - HIGHTS (Copy)" (a03cQ2E7npwBPY2ioObUOD) -> Community / Web
// (576:18822): Landing desktop (235:2068) / mobile (363:9081), Event (987:17150, 367:2839),
// Event / Tickets (235:8023), Shop (1158:14862). White content card split by #d5d5d5 dividers,
// black aside, lime #c4f233 filled buttons.
const HIGHTS: CommunityData = {
  code: "hights",
  inviteCode: "hights",
  name: "HIGHTS",
  thumbnail: "",
  favicon: "",
  defaultCurrency: "SEK",
  url: `${COMMUNITY_PAGES_PATH_PREFIX}/hgh-080`,
  waitlist: false,
  socials: {},
  styles: {
    global: {
      counterColor: "#000000",
      werzLogoColor: "#ffffff",
      // Square icon (black, white smiley) for the white surfaces that read logo.src: the join
      // gate's 96px circle, the claim card and the download page
      logo: {
        src: `${S3_PREFIX}community-icon-v2.jpg`,
        styles: "w-[96px] h-[96px] object-contain",
      },
      // White lockup for the black aside / mobile menu, which prefers alternativeLogo
      alternativeLogo: {
        src: `${S3_PREFIX}web-logo.png`,
        styles: "w-[140px] h-[121px] object-contain",
      },
      modalWindow: {
        container: "",
        title: "",
        subtitle: "",
      },
      bgColor: "#000000",
      asideBg: "#000000",
      asideStyles: "!p-0 !gap-0 border-r border-[#8d8d8d]",
      contentBg: "#ffffff",
      contentBoxShadow: "",
      bgDesktop: `${S3_PREFIX}web-background.jpg`,
      bgMobile: `${S3_PREFIX}web-background-mobile.jpg`,
      nonMemberBg: `${S3_PREFIX}web-background-non-member.jpg`,
      // Full-height background behind the join gate (Figma 235:9051 is full-bleed)
      nonMemberBgContainerStyles: "sm:!h-screen",
      mainFont: "font-['SyneMonoRegular']",
      primaryButton:
        "bg-[#c4f233] border border-[#c4f233] !px-[18px] !h-[46px] sm:!h-[46px] !text-[#000000] font-['SyneMonoRegular'] !text-[16px] uppercase text-left leading-[100%]",
      scrollArrow: {
        background: "#c4f233",
        color: "#000000",
      },
    },
    navigation: {
      iconsColor: "#ffffff",
      sideBarSeparator: "border-r-[1px] border-[#8d8d8d]",
      separator: "border-[#d5d5d5]",
      item: "font-['SyneMonoRegular'] text-[16px] text-[#ffffff] uppercase leading-[100%] gap-x-[10px] text-opacity-50 text-center border-b border-[#d5d5d5] !pl-0 !py-4",
      itemSelected: " !text-opacity-100",
    },
    communityLanding: {
      container: "!bg-[#ffffff] overflow-hidden !pt-0 !pb-4 sm:!pb-8 !mb-0",
      titles:
        "text-[#000000] font-['SyneRegular'] text-[26px] tracking-[0.14em] uppercase text-left leading-[100%]",
      emptyOrLoadingState:
        "!mx-4 sm:!mx-8 text-[#8d8d8d] font-['SyneMonoRegular'] text-[13px] text-left leading-[110%]",
      announcementsV2: {
        sectionContainer: "py-4 sm:py-8 !m-0 space-y-0 !border-0 !border-b border-[#d5d5d5]",
        sectionTitle:
          "text-[#000000] font-['SyneRegular'] text-[26px] tracking-[0.14em] uppercase text-left leading-[100%] pl-4 sm:pl-8 !mb-4",
        scrollMenu: {
          container: "content-start hide-scroll pl-4 sm:pl-8 pr-6 sm:pr-8 gap-x-6",
          wrapper: "relative group",
          item: "w-fit",
        },
        item: {
          container:
            "min-w-[calc(100vw-48px)] sm:min-w-[256px] sm:max-w-[256px] overflow-hidden !bg-[#ffffff00]",
          mediaContainer: "w-full sm:w-[256px] relative overflow-hidden",
          media: "w-full !aspect-square object-cover",
          placeholderMedia: "w-full !aspect-square bg-gray-400",
          content: "flex flex-col px-0 pt-4 bg-transparent",
          title: "text-[#000000] font-['SyneMedium'] text-[20px] text-left leading-[110%]",
          subtitle:
            "text-[#8d8d8d] font-['SyneMonoRegular'] text-[13px] text-left leading-[110%] mt-2",
        },
      },
      eventsV2: {
        sectionContainer: "py-4 sm:py-8 !m-0 space-y-0 !border-0 !border-b border-[#d5d5d5]",
        sectionTitle:
          "text-[#000000] font-['SyneRegular'] text-[26px] tracking-[0.14em] uppercase text-left leading-[100%] pl-4 sm:pl-8 !mb-4",
        scrollMenu: {
          container:
            "content-start hide-scroll pl-4 sm:pl-8 pr-6 sm:pr-8 !h-full sm:!h-[128px] flex-row gap-6",
          wrapper: "relative group w-full",
          item: "w-fit",
        },
        item: {
          container:
            "flex sm:flex-row flex-col w-[calc(100vw-56px)] sm:!w-[420px] h-full overflow-hidden !bg-[#ffffff00]",
          mediaContainer: "w-full sm:!w-[228px] sm:flex-shrink-0 relative overflow-hidden",
          media: "w-full !aspect-video object-cover",
          placeholderMedia: "w-full !aspect-video bg-gray-400",
          content: "flex flex-col px-0 sm:pl-3 sm:pr-0 pt-4 sm:!pt-0 bg-transparent",
          title:
            "text-[#000000] font-['SyneMedium'] text-[20px] sm:text-[17px] text-left leading-[110%]",
          subtitle:
            "text-[#8d8d8d] font-['SyneMonoRegular'] text-[13px] sm:text-[11px] text-left leading-[110%] mt-2",
          location:
            "text-[#8d8d8d] font-['SyneMonoRegular'] text-[13px] sm:text-[11px] text-left leading-[110%] mt-1",
          date: "text-[#8d8d8d] font-['SyneMonoRegular'] text-[13px] sm:text-[11px] text-left leading-[110%] mt-2",
        },
      },
      shop: {
        container: "py-4 sm:py-8 !m-0 space-y-0 !border-0 overflow-hidden",
        title: "text-[#000000] font-['SyneMedium'] text-[24px] text-left leading-[110%]",
        text: "text-[#000000] font-['SyneMonoRegular'] text-[15px] text-left leading-[110%]",
        // Component hardcodes 456x288; Figma is 420x236 desktop, full-width 16:9 mobile.
        customShopImageStyle: "!h-auto !aspect-video sm:!w-[420px]",
        sectionTitle:
          "text-[#000000] font-['SyneRegular'] text-[26px] tracking-[0.14em] uppercase text-left leading-[100%] !mb-4 sm:!mb-6",
      },
    },
    eventV2: {
      container: "flex flex-col !bg-[#ffffff] overflow-hidden !pb-4 sm:!pb-8",
      eventInfo: {
        container: "flex flex-col sm:flex-row gap-4 sm:gap-8 sm:p-8 p-4 border-b border-[#d5d5d5]",
        media: "!w-full sm:!w-[320px] !h-auto !aspect-video object-cover sm:mb-4 !border-0",
        title:
          "text-[#000000] font-['SyneMedium'] text-[24px] sm:text-[32px] text-left leading-[110%]",
        subtitle:
          "text-[#8d8d8d] font-['SyneMonoRegular'] text-[13px] text-left leading-[110%] mb-4 mt-2",
        button: "!w-fit mb-4 sm:mb-0",
        questions: "font-['SyneMonoRegular'] text-[13px] leading-[110%] text-left !text-[#8d8d8d]",
      },
      about: {
        container: "flex flex-col gap-4 sm:p-8 p-4 border-b border-[#d5d5d5]",
        header: "text-[#000000] font-['SyneMedium'] text-[24px] text-left leading-[110%]",
        text: "text-[#000000] font-['SyneMonoRegular'] text-[13px] text-left leading-[110%] w-full",
      },
      location: {
        container: "flex flex-col gap-4 sm:p-8 p-4 border-b border-[#d5d5d5]",
        header: "text-[#000000] font-['SyneMedium'] text-[24px] text-left leading-[110%]",
        text: "text-[#000000] font-['SyneMonoRegular'] text-[13px] text-left leading-[110%] max-w-[652px] w-full",
        // Wrappers hardcode 307x204 / 309x206; Figma is 350x196 desktop, full-width 16:9 mobile.
        map: "!w-full sm:!w-[350px] !h-auto !aspect-video overflow-hidden",
        mapPinColor: "#000000",
        mapStrokeColor: "#ffffff00",
      },
      downloadWERZ: {
        container: "flex flex-col gap-4 sm:gap-6 sm:p-8 p-4",
        header: "text-[#000000] font-['SyneMedium'] text-[24px] text-left leading-[110%]",
        text: "text-[#000000] font-['SyneMonoRegular'] text-[15px] text-left leading-[110%]",
      },
      tickets: {
        // First ticket's py-4 adds 16px, so mb-2 lands on Figma's 24px header gap on desktop.
        header:
          "text-[#000000] font-['SyneMedium'] text-[24px] text-left leading-[110%] px-4 sm:px-8 pt-4 sm:pt-8 mb-0 sm:mb-2 flex justify-between items-center",
        outerContainer: "flex flex-col !bg-[#ffffff] !pb-4 sm:!pb-8",
        innerContainer: "flex flex-col overflow-hidden px-4 sm:px-8",
        accessCode: {
          button:
            "bg-[#ffffff] border border-[#000000] flex items-center justify-center px-[12px] text-[#000000] font-['SyneMonoRegular'] text-[14px] uppercase leading-[100%] !w-fit !h-[33px]",
        },
        ticket: {
          container:
            "flex flex-row justify-between gap-x-4 leading-auto !bg-[#ffffff00] border-b border-[#d5d5d5] overflow-hidden py-4",
          mediaContainer: "!hidden",
          media: "!hidden",
          name: "text-[#000000] font-['SyneMedium'] text-[17px] text-left leading-[110%] mb-1",
          description:
            "text-[#8d8d8d] font-['SyneMonoRegular'] text-[13px] text-left leading-[110%] mb-1",
          price: "text-[#8d8d8d] font-['SyneMedium'] text-[17px] text-left leading-[110%]",
          quantity:
            "text-[#000000] font-['SyneMonoRegular'] text-[14px] uppercase text-left leading-[100%]",
          status: "text-[#8d8d8d] font-['SyneMedium'] text-[17px] text-left leading-[110%]",
          counterContainer:
            "bg-[#ffffff] border border-[#000000] px-[12px] py-[12px] gap-x-[16px] !w-fit !h-9",
          plusMinusColor: "#000000",
          button:
            "bg-[#ffffff] border border-[#000000] flex items-center justify-center px-[12px] text-[#000000] font-['SyneMonoRegular'] text-[14px] uppercase leading-[100%] !w-fit !h-[33px]",
          descriptionCutoff: 30,
        },
      },
    },
    shopV2: {
      container: "flex flex-col !bg-[#ffffff] overflow-hidden !pb-8",
      header:
        "text-[#000000] font-['SyneRegular'] text-[26px] tracking-[0.14em] uppercase text-left leading-[100%] px-4 sm:px-8 pt-4 sm:pt-8",
      emptyState:
        "text-[#8d8d8d] font-['SyneMonoRegular'] text-[13px] text-left leading-[110%] px-4 sm:px-8 py-8",
      eventSection: {
        // first:pt-0 offsets the hard-coded mb-9 under the SHOP header (Figma gap is 32px)
        container: "px-4 sm:px-8 py-4 sm:py-8 sm:first:pt-0 border-b border-[#d5d5d5]",
        header: "text-[#000000] font-['SyneMedium'] text-[24px] text-left leading-[110%] mb-6",
        event: {
          container: "flex items-start gap-x-3 mb-6",
          dateBox:
            "bg-[#c4f233] border border-[#c4f233] p-1 w-[68px] h-[68px] flex flex-col items-center justify-center text-center shrink-0",
          month:
            "text-[#000000] font-['SyneMedium'] text-[17px] uppercase leading-[110%] text-center",
          day: "text-[#000000] font-['SyneMedium'] text-[17px] uppercase leading-[110%] text-center",
          details: "flex-1 min-w-0",
          name: "text-[#000000] font-['SyneMedium'] text-[17px] text-left leading-[110%]",
          date: "text-[#8d8d8d] font-['SyneMonoRegular'] text-[11px] text-left leading-[110%] mt-2",
          location:
            "text-[#8d8d8d] font-['SyneMonoRegular'] text-[11px] text-left leading-[110%] mt-1",
        },
        tickets: {
          container: "flex flex-col overflow-hidden",
          ticket: {
            container:
              "flex flex-row justify-between items-start gap-x-4 leading-auto border-b border-[#d5d5d5] py-2",
            mediaContainer: "!hidden",
            media: "!hidden",
            name: "text-[#000000] font-['SyneMedium'] text-[17px] text-left leading-[110%]",
            description:
              "text-[#8d8d8d] font-['SyneMonoRegular'] text-[13px] text-left leading-[110%] mt-1",
            price: "text-[#8d8d8d] font-['SyneMedium'] text-[17px] text-left leading-[110%] mt-1",
            quantity:
              "text-[#000000] font-['SyneMonoRegular'] text-[14px] uppercase text-left leading-[100%]",
            status: "text-[#8d8d8d] font-['SyneMedium'] text-[17px] text-left leading-[110%]",
            counterContainer:
              "bg-[#ffffff] border border-[#000000] px-[12px] py-[12px] gap-x-[16px] !w-fit !h-9",
            plusMinusColor: "#000000",
            button:
              "bg-[#ffffff] border border-[#000000] flex items-center px-[12px] text-[#000000] font-['SyneMonoRegular'] text-[14px] uppercase text-left leading-[100%] !w-fit !h-[33px]",
            descriptionCutoff: 50,
          },
        },
      },
      membershipSection: {
        container: "px-4 sm:px-8 py-4 sm:py-8 border-b border-[#d5d5d5]",
        header: "text-[#000000] font-['SyneMedium'] text-[24px] text-left leading-[110%] mb-6",
        products: {
          container: "flex flex-col overflow-hidden",
          product: {
            container:
              "flex flex-row justify-between items-start gap-x-4 leading-auto border-b border-[#d5d5d5] py-2",
            mediaContainer: "!hidden",
            media: "!hidden",
            name: "text-[#000000] font-['SyneMedium'] text-[17px] text-left leading-[110%]",
            description:
              "text-[#8d8d8d] font-['SyneMonoRegular'] text-[13px] text-left leading-[110%] mt-1",
            price: "text-[#8d8d8d] font-['SyneMedium'] text-[17px] text-left leading-[110%] mt-1",
            quantity:
              "text-[#000000] font-['SyneMonoRegular'] text-[14px] uppercase text-left leading-[100%]",
            status: "text-[#8d8d8d] font-['SyneMedium'] text-[17px] text-left leading-[110%]",
            counterContainer:
              "bg-[#ffffff] border border-[#000000] px-[12px] py-[12px] gap-x-[16px] !w-fit !h-9",
            plusMinusColor: "#000000",
            // Subscribe is the lime (primary) button in the design, unlike Buy.
            button:
              "bg-[#c4f233] border border-[#c4f233] flex items-center px-[12px] text-[#000000] font-['SyneMonoRegular'] text-[14px] uppercase text-left leading-[100%] !w-fit !h-[33px]",
            descriptionCutoff: 50,
          },
        },
      },
      merchSection: {
        container: "px-4 sm:px-8 py-4 sm:py-8",
        header: "text-[#000000] font-['SyneMedium'] text-[24px] text-left leading-[110%] mb-6",
        products: {
          container: "grid grid-cols-2 sm:grid-cols-4 gap-4",
          product: {
            container: "cursor-pointer !bg-[#ffffff00] overflow-hidden",
            innerContainer: "flex flex-col",
            mediaContainer: "w-full overflow-hidden",
            media: "w-full !aspect-square object-cover",
            name: "text-[#000000] font-['SyneMedium'] text-[17px] text-left leading-[110%] mt-3",
            description:
              "text-[#8d8d8d] font-['SyneMonoRegular'] text-[13px] text-left leading-[110%] mt-1",
            price: "text-[#8d8d8d] font-['SyneMedium'] text-[17px] text-left leading-[110%] mt-1",
            quantity:
              "text-[#000000] font-['SyneMonoRegular'] text-[14px] uppercase text-left leading-[100%]",
            status: "text-[#8d8d8d] font-['SyneMedium'] text-[17px] text-left leading-[110%]",
            counterContainer:
              "bg-[#ffffff] border border-[#000000] px-[12px] py-[12px] gap-x-[16px] !w-fit !h-9",
            plusMinusColor: "#000000",
            button:
              "bg-[#ffffff] border border-[#000000] flex items-center px-[12px] text-[#000000] font-['SyneMonoRegular'] text-[14px] uppercase text-left leading-[100%] !w-fit !h-[33px]",
            descriptionCutoff: 50,
          },
        },
      },
    },
  },
}

export default HIGHTS
